import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const missingVariables = [
  ['VITE_SUPABASE_URL', supabaseUrl],
  ['VITE_SUPABASE_ANON_KEY', supabaseKey],
]
  .filter(([, value]) => !value)
  .map(([name]) => name);

export const supabaseConfig = {
  url: supabaseUrl,
  anonKey: supabaseKey,
  isConfigured: missingVariables.length === 0,
  missingVariables,
};

const clientUrl = supabaseConfig.isConfigured ? supabaseUrl : 'https://missing-supabase-config.supabase.co';
const clientKey = supabaseConfig.isConfigured ? supabaseKey : 'missing-supabase-anon-key';

export const supabase = createClient(clientUrl, clientKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storage: window.localStorage,
    storageKey: 'supabase.auth.token',
    debug: false
  },
  global: {
    headers: {
      'X-Client-Info': 'scalesmall-onboarding'
    }
  },
  realtime: {
    params: {
      eventsPerSecond: 2
    }
  },
  db: {
    schema: 'public'
  }
});

if (supabaseConfig.isConfigured) {
  supabase.auth.onAuthStateChange((event) => {
    if (event === 'SIGNED_OUT' || event === 'USER_DELETED') {
      localStorage.removeItem('supabase.auth.token');
    }
  });
}
